import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AirportShuttle from "../pages/airport-shuttle/page";
import About from "../pages/about/page";
import Careers from "../pages/careers/page";
import ContactUs from "../pages/contact-us/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/airport-shuttle",
    element: <AirportShuttle />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/careers",
    element: <Careers />,
  },
  {
    path: "/contact-us",
    element: <ContactUs />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;